export default "/images/c6f5c5ff8878c3d871b6e69b1695efa8.avif";